export const buildStatusSummaryChartData = (summaryData) => ({
    labels: summaryData.map((data) => data.serialNumber),
    datasets: [
        {
            label: 'PASS',
            data: summaryData.map((data) => Number(data.passCount) || 0),
            backgroundColor: 'rgba(47, 158, 68, 0.72)',
        },
        {
            label: 'FAIL',
            data: summaryData.map((data) => Number(data.failCount) || 0),
            backgroundColor: 'rgba(214, 69, 69, 0.72)',
        },
        {
            label: 'STOP',
            data: summaryData.map((data) => Number(data.stopCount) || 0),
            backgroundColor: 'rgba(91, 141, 239, 0.72)',
        },
        {
            label: 'UNCOMPLETE',
            data: summaryData.map((data) => Number(data.uncompleteCount) || 0),
            backgroundColor: 'rgba(242, 153, 74, 0.74)',
        },
    ],
});

export const statusSummaryChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: {
            display: true,
            position: 'bottom',
        },
    },
    scales: {
        y: {
            beginAtZero: true,
        },
    },
};

export const isPassOnlyRow = (data) =>
    Number(data.passCount) > 0 &&
    Number(data.failCount) === 0 &&
    Number(data.stopCount) === 0 &&
    Number(data.uncompleteCount) === 0;

export const sortStatusSummaryRows = (summaryData) => [...summaryData].sort((a, b) => {
    const aIsPassOnly = isPassOnlyRow(a) ? 1 : 0;
    const bIsPassOnly = isPassOnlyRow(b) ? 1 : 0;

    if (aIsPassOnly !== bIsPassOnly) return bIsPassOnly - aIsPassOnly;
    return String(a.serialNumber).localeCompare(String(b.serialNumber));
});

export const getSummaryMetrics = (summaryData) => {
    const totals = summaryData.reduce((acc, row) => ({
        pass: acc.pass + (Number(row.passCount) || 0),
        fail: acc.fail + (Number(row.failCount) || 0),
        stop: acc.stop + (Number(row.stopCount) || 0),
        uncomplete: acc.uncomplete + (Number(row.uncompleteCount) || 0),
    }), { pass: 0, fail: 0, stop: 0, uncomplete: 0 });
    const passOnlySerials = summaryData.filter((row) => isPassOnlyRow(row)).length;

    return [
        { label: 'Serial numbers', value: summaryData.length, tone: 'neutral' },
        { label: 'Serials without fail', value: passOnlySerials, tone: 'pass' },
        { label: 'PASS records', value: totals.pass, tone: 'pass' },
        { label: 'FAIL records', value: totals.fail, tone: 'fail' },
        { label: 'STOP records', value: totals.stop, tone: 'neutral' },
        { label: 'UNCOMPLETE', value: totals.uncomplete, tone: 'warning' },
    ];
};
